import React from 'react';
import { TextField } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useMap } from '../map';
function LocationPanel() {
    const { center, setCenter } = useMap();
    const theme = useTheme();
    // 編集中の生テキスト。フォーカスが外れると parse して setCenter に反映する。
    const [editing, setEditing] = React.useState(false);
    const [inputValue, setInputValue] = React.useState('');
    const displayValue = editing
        ? inputValue
        : center
            ? `${center.lat.toFixed(6)}  ${center.lng.toFixed(6)}`
            : 'N/A';
    const applyInput = (raw) => {
        // "35.615 139.82" / "35.615,139.82" / "35.615　139.82" の形式を受け入れる
        const parts = raw.trim().split(/[\s,、　]+/);
        if (parts.length >= 2) {
            const lat = parseFloat(parts[0]);
            const lng = parseFloat(parts[1]);
            if (!isNaN(lat) && !isNaN(lng) && lat >= -90 && lat <= 90 && lng >= -180 && lng <= 180) {
                setCenter?.({ lat, lng });
            }
        }
    };
    return (React.createElement(TextField, { label: "Map Center", margin: "none", color: "primary", inputProps: {
            style: {
                padding: '0 !important',
                fontSize: '0.8rem',
                color: theme.palette.text.primary,
            },
        }, InputProps: {
            sx: {
                '&::before': {
                    borderWidth: 0,
                },
            },
        }, placeholder: "lat  lng", value: displayValue, onChange: (e) => setInputValue(e.target.value), onFocus: () => {
            setEditing(true);
            setInputValue(center ? `${center.lat.toFixed(6)}  ${center.lng.toFixed(6)}` : '');
        }, onBlur: () => {
            setEditing(false);
            applyInput(inputValue);
        }, onKeyDown: (e) => {
            if (e.key === 'Enter') {
                e.target.blur();
            }
        } }));
}
export default React.memo(LocationPanel);
